export default __webpack_public_path__ + "static/media/LogoIstatFooter.5b90ed00.svg";